import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('Friends').create(({ theme }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    width: '100%',
    padding: '12px',
    paddingBottom: '164px',
  },

  heading: {
    fontSize: '24px',
    fontWeight: 450,
    textAlign: 'center',
    color: 'white',
  },
  subHeading: {
    fontSize: '18px',
    fontWeight: 450,
    textAlign: 'left',
    color: 'white',
  },

  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    width: '100%',
  },

  inputWrapper: {
    width: '100%',
    background: 'rgba(255, 255, 255, 0.09)',
    padding: '12px',
    gap: '0px',
    height: '48px',
    display: 'flex',
    alignItems: 'center',
    border: 'none',
    borderRadius: '8px',
  },

  input: {
    flex: 1,
    backgroundColor: 'transparent',
    border: 'none',
    outline: 'none',
    fontSize: 14,
    fontWeight: 400,
    color: 'white',
    fontFamily: 'inherit',

    '::placeholder': {
      color: theme.colors.text.secondary,
      fontSize: 14,
      fontWeight: 300,
    },

    ':focus': {
      outline: 'none',
    },
  },

  noResultsWrapper: {
    display: 'flex',
    gap: '4px',
    flexDirection: 'column',
  },

  noResults: {
    fontSize: '14px',
    fontWeight: 350,
    lineHeight: '20px',
    color: theme.colors.text.secondary,
    textAlign: 'center',
  },
  noResultsId: {
    fontSize: '17px',
    fontWeight: 450,
    lineHeight: '20px',
    color: theme.colors.text.primary,
    textAlign: 'center',
  },
}))
